import React from "react";
import { widgetRect } from "./boardSchema";
import { getWidget } from "./widgetRegistry";

// Isolates a single widget: positions it on the stage and contains any render
// error so one bad widget never blanks the whole board (third-party embeds in
// the media widget are the usual culprit).
class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Widget crashed:", this.props.type, error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="sb-widget-error">
          <span>{this.props.type} unavailable</span>
        </div>
      );
    }
    return this.props.children;
  }
}

const WidgetFrame = ({ widget, stage, agency, board }) => {
  const rect = widgetRect(widget, stage);
  const Component = getWidget(widget.type);
  return (
    <div
      className="sb-widget"
      style={{
        position: "absolute",
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        overflow: "hidden",
      }}
    >
      <WidgetErrorBoundary type={widget.type}>
        <React.Suspense fallback={<div className="sb-widget-loading" />}>
          <Component config={widget.config || {}} agency={agency} board={board} stage={stage} />
        </React.Suspense>
      </WidgetErrorBoundary>
    </div>
  );
};

export default WidgetFrame;
